/* eslint-disable no-undef */
class LayoutSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.els.single.element.addEventListener(
      'click',
      this.handleSingle.bind(this)
    )
    this.els.double.element.addEventListener(
      'click',
      this.handleDouble.bind(this)
    )
    this.els.label.element.addEventListener(
      'click',
      this.handleLabel.bind(this)
    )
  }

  handleSingle () {
    this.els.double.element.setAttribute('aria-active', 'false')
    this.els.single.element.setAttribute('aria-active', 'true')
    this.externalEls.layout.element.classList.add('clc-List_Items-single')
  }

  handleDouble () {
    this.els.single.element.setAttribute('aria-active', 'false')
    this.els.double.element.setAttribute('aria-active', 'true')
    this.externalEls.layout.element.classList.remove('clc-List_Items-single')
  }

  handleLabel () {
    const isSingleActive =
      this.els.single.element.getAttribute('aria-active') === 'true'

    if (isSingleActive) {
      // If single layout is active, switch to double layout
      this.handleDouble()
    } else {
      // If double layout is active, switch to single layout
      this.handleSingle()
    }
  }
}

if (!customElements.get('layout-switch')) {
  customElements.define('layout-switch', LayoutSwitch)
}
